import classNames from "classnames";
import React from "react";

import Link from "../../SquaberLink";

const IconMessage = ({
  title,
  description,
  link,
  linkText,
  icon,
  imageSrc,
  imageWidth,
  imageHeight,
  className,
  onLinkClick
}) => (
  <div
    className={classNames(
      "flex flex-col justify-center align-center text-center max-w-82 mx-auto",
      className
    )}
  >
    {icon ? (
      <div
        className={
          title || description || linkText
            ? "mb-4 flex justify-center"
            : undefined
        }
      >
        {icon}
      </div>
    ) : (
      <img
        src={imageSrc}
        alt=""
        width={imageWidth}
        height={imageHeight}
        className={title || description || linkText ? "mb-2" : undefined}
      />
    )}
    {title ? (
      <strong className="text-base text-black font-bold mb-2">{title}</strong>
    ) : null}
    {description ? (
      <p className="text-black-5 font-medium mb-6 text-xs line-height-130">
        {description}
      </p>
    ) : null}
    {linkText ? (
      link ? (
        <Link
          to={link}
          className={classNames("button-4")}
          onClick={onLinkClick}
        >
          {linkText}
        </Link>
      ) : (
        <button
          type="button"
          className={classNames("button-4 border-0")}
          onClick={onLinkClick}
        >
          {linkText}
        </button>
      )
    ) : null}
  </div>
);

export default IconMessage;
